import * as React from 'react';
import {ConverterAidedFileViewer} from "./ConverterAidedFileViewer";
import {Button, ButtonGroup} from "semantic-ui-react";
import {TextFileViewer} from "./TextFileViewer";

export interface JsonMailProps {
    blob: any,
    fileName: string
    fileBuffer: ArrayBuffer
}

export function JsonMailViewer(props: JsonMailProps) {

    const [viewMode, setViewMode] = React.useState<'pdf' | 'text'>('pdf');

    return <>
        <ButtonGroup>
            <Button
                onClick={() => setViewMode('pdf')}
                disabled={viewMode === 'pdf'}
                style={{height: '25px', padding: '0px'}}
            >
                PDF View
            </Button>
            <Button
                onClick={() => setViewMode('text')}
                disabled={viewMode === 'text'}
                style={{height: '25px', padding: '0px'}}
            >
                Text View
            </Button>
        </ButtonGroup>
        {viewMode === 'pdf' && <ConverterAidedFileViewer
            blob={props.blob}
            fileName={props.fileName}
        />
        }
        {viewMode === 'text' && <TextFileViewer
            buffer={props.fileBuffer}
            fileName={props.fileName}
        />
        }
    </>

}